function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import rgba from 'polished/lib/color/rgba';
import hideVisually from 'polished/lib/mixins/hideVisually';
var useStyles = _ref => {
  var {
    active,
    columnResize,
    hasFilter,
    hasFilters,
    isColumnResizing,
    isResizeActive,
    isResizeHovered,
    noWrap,
    showFilters,
    sortableType,
    theme
  } = _ref;
  return React.useMemo(() => ({
    root: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
      boxSizing: 'border-box',
      cursor: isColumnResizing ? 'col-resize' : undefined,
      fontWeight: 'normal',
      padding: "calc(".concat(theme.orbitalFour, " - 2px) ").concat(theme.orbitalThree),
      paddingBottom: hasFilters && showFilters ? theme.layout.size2 : undefined,
      position: 'relative',
      textAlign: 'left',
      textTransform: hasFilter ? 'none' : 'inherit',
      verticalAlign: 'middle',
      whiteSpace: 'nowrap',
      touchAction: columnResize ? 'none' : undefined
    }, hasFilter && {
      paddingTop: 0,
      paddingBottom: theme.orbitalThree
    }), noWrap ? {
      'span, div': {
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    } : {
      whiteSpace: 'normal'
    }), isResizeActive && {
      backgroundColor: theme.palette.primary.backgroundLight,
      color: theme.palette.primary.active
    }), theme.mode === 'contrast' && _objectSpread(_objectSpread({}, isResizeHovered && {
      backgroundColor: rgba(theme.palette.primary.hover, 0.1),
      color: theme.palette.foreground.default
    }), isResizeActive && {
      backgroundColor: rgba(theme.palette.primary.active, 0.1),
      color: theme.palette.foreground.default
    })),
    sortableButton: _objectSpread({
      alignItems: 'center',
      backgroundColor: 'transparent',
      border: 0,
      color: active ? theme.palette.foreground.default : 'inherit',
      cursor: 'pointer',
      display: 'flex',
      fontFamily: 'inherit',
      fontSize: 'inherit',
      lineHeight: 'inherit',
      margin: 0,
      padding: 0,
      textTransform: 'inherit',
      transition: 'color 150ms ease',
      width: '100%',
      '&:hover': {
        color: theme.palette.primary.hover,
        '> svg': {
          opacity: 0.8,
          fill: theme.palette.primary.hover
        }
      },
      '&:active': {
        color: theme.palette.primary.active,
        '> svg': {
          opacity: 0.8,
          fill: theme.palette.primary.active
        }
      }
    }, theme.mode === 'contrast' && {
      color: theme.palette.primary.default
    }),
    sortableIcon: {
      fill: theme.palette.primary.default,
      height: 16,
      marginLeft: theme.orbitalTwo,
      opacity: active ? 1 : 0,
      padding: 0,
      transform: sortableType === 'ascending' || !active ? 'rotate(-180deg)' : undefined,
      transition: 'opacity 150ms ease, transform 0.5s ease',
      userSelect: 'none',
      width: 16,
      '&:hover': {
        fill: theme.palette.primary.hover
      },
      '&:active': {
        fill: theme.palette.primary.active
      }
    },
    sortableLabel: hideVisually(),
    // Why are these two here? To preserve emotion snapshots, that's why.
    headerContainer: undefined,
    labelWrapper: undefined
  }), [active, columnResize, hasFilter, hasFilters, isColumnResizing, isResizeActive, isResizeHovered, noWrap, showFilters, sortableType, theme]);
};
export default useStyles;